
export default {
  data() {
    return {
        en: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'AA', 'AB', 'AC', 'AD', 'AE', 'AF', 'AG', 'AH', 'AI', 'AJ', 'AK', 'AL', 'AM', 'AN', 'AO', 'AP', 'AQ', 'AR', 'AS', 'AT', 'AU', 'AV', 'AW', 'AX', 'AY', 'AZ', 'BA', 'BB', 'BC', 'BD', 'BE'],
        items: [
          {
            label: '住宅',
            value: '住宅'
          },
          {
            label: '住宅商业',
            value: '住宅商业'
          },
          {
            label: '普通商业',
            value: '普通商业'
          },
          {
            label: '研发用房',
            value: '研发用房'
          },
          {
            label: '商务公寓',
            value: '商务公寓'
          },
          {
            label: '酒店',
            value: '酒店'
          },
          {
            label: '办公',
            value: '办公'
          },
          {
            label: '工业',
            value: '工业'
          },
          {
            label: '仓储',
            value: '仓储'
          }
        ],
        et1: '住宅',
        et2: '住宅',
        et3: '住宅',
        et4: '住宅',
        et5: '住宅',
        et6: '住宅商业',
        et7: '普通商业',
        et8: '工业',
        et9: '工业',
        et10: '办公',
        et11: '宿舍',
        et12: '商务公寓',
        et13: '办公',
        et14: '',
        et15: '',
        et16: '',

    }
  },
  props: {
   
  },
  mounted() {      
  },
  methods: {
    changeSelection(e, val) {      
          let target = this.$refs[`et${val}`].$el          
          this.$emit('changeSelection', {target, value: e })
        
    },
    assignColumnIds(tableId, startingCellId) {
        const table = document.getElementById(tableId);
        const rows = table.getElementsByTagName("tr");        
        for (let i = 0; i< rows.length; i++) {
            if (i > 1) {
              const row = rows[i];
              const cells = row.getElementsByTagName("td");
              for (let k = 0; k < cells.length; k++) {
                if ( k > 0) {
                  let cell = cells[k]  
                  if ( i == 3 || i == 6 || i == 14) {                  
                    cell.setAttribute("id", `${this.en[k + 1]}${(startingCellId + i - 2)}`)
                  } else if ( i == 8 || i == 9 || i == 10 ) {
                    cell.setAttribute("id", `${this.en[k + 1]}${(startingCellId + i - 2)}`)
                  }
                  else {
                    cell.setAttribute("id", `${this.en[k]}${(startingCellId + i - 2)}`)
                  } 
                }
                        
                
                
              }
            }
            
        }
      },

  },
};
